/**
 * Whether the voice is on, heard as its switch moves.
 *
 * Every figure printed before a press includes the voice's line while it is on
 * (D295), and the switch is its own key rather than a store field, so no store
 * selector hears it move. A surface that prints a figure calls this, and re-reads
 * the figure when the switch moves, rather than showing the old one until some
 * other change happens to render it again. Not a root re-render: rows the feed
 * memoizes would not be reached by one.
 */

import { useSyncExternalStore } from 'react'
import { onVoiceChange, voiceOn } from '../core/voice'

export const useVoiceOn = (): boolean => useSyncExternalStore(onVoiceChange, voiceOn, voiceOn)
